import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type MapIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const MapIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: MapIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Map'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 6.5 8.5 3.5 15.5 6.5 22 3.5V17.5L15.5 20.5 8.5 17.5 2 20.5V6.5Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M8.5 3.5V17.5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M15.5 6.5V20.5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
